import type { EndpointDefinition } from "../_sdk/types/common";

export const apiName = "presentations";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getPresentation: {
        method: "GET",
        route: "/presentations/:id",
    },
    createPresentationWithSlidesAndResource: {
        method: "POST",
        route: "/presentations",
    },
    updatePresentation: {
        method: "PUT",
        route: "/presentations/:id",
    },
    deletePresentation: {
        method: "DELETE",
        route: "/presentations/:id",
    },

    copyPresentation: {
        method: "PUT",
        route: "/presentations/:id/copy",
    },
    moveWorkspace: {
        method: "PUT",
        route: "/presentations/:id/move",
    },
    recordActivity: {
        method: "PUT",
        route: "/presentations/:id/activity",
    },

    getSlidesMetadata: {
        method: "GET",
        route: "/presentations/:id/slidesMetadata",
    },
    updateSlidesMetadata: {
        method: "PUT",
        route: "/presentations/:id/slidesMetadata",
    },

    createLink: {
        method: "POST",
        route: "/presentations/:id/links",
    },
    getLink: {
        method: "GET",
        route: "/presentations/:id/links/:linkId",
    },
    updateLink: {
        method: "PUT",
        route: "/presentations/:id/links/:linkId",
    },
    deleteLink: {
        method: "DELETE",
        route: "/presentations/:id/links/:linkId",
    },
    updateLinkPassword: {
        method: "PUT",
        route: "/presentations/:id/links/:linkId/password",
    },
    connectEmbedLinkDomains: {
        method: "PUT",
        route: "/presentations/:id/links/:linkId/embedLinkDomains"
    },
    incrementLinkViewCount: {
        method: "PUT",
        route: "/presentations/:id/links/:linkId/viewCount",
    },

    getSlideCount: {
        method: "POST",
        route: "/presentations/slideCount",
    },
    getPresentationLastModifiedData: {
        method: "GET",
        route: "/presentations/:id/lastModifiedData",
    }
};
